<div class="flex flex-wrap w-full h-full">
    @if(isLoading){
            <div class="h-full w-full flex justify-center items-center flex-col">
                <div class="scene">
                    <div class="w-[4.5rem] h-[4.5rem] bg-[#f8fafcf7] loader-box"></div>
                </div>

                <p class="text-[#f8fafcf7] text-sm mt-10">
                    Loading...
                </p>
            </div>
            }  

            @else {
    <div class="flex-col flex w-full p-3">
        <div class="flex  gap-2 p-2 justify-between">
            <div class="flex gap-2">

                <button class="bg-transparent border-2 border-white text-white p-2 min-w-[100px] rounded-2xl"
                    (click)="fetchRudrapurDetails()"
                    [ngClass]="curPlant===holiumPlantType.rudrapur?'selected':''">Rudrapur Plant</button>
                <button class="bg-transparent border-2 border-white text-white p-2 min-w-[100px] rounded-2xl"
                    (click)="fetchHaridwarDetails()"
                    [ngClass]="curPlant===holiumPlantType.haridwar?'selected':''">Haridwar Plant</button>
                <button class="bg-transparent border-2 border-white text-white p-2 min-w-[100px] rounded-2xl"
                    (click)="fetchBaddiDetails()" [ngClass]="curPlant===holiumPlantType.baddi?'selected':''">Baddi
                    Plant</button>
            </div>

            <div class="flex items-center justify-center text-white">
                <span>Last updated : {{fetchTime}}</span>
            </div>

        </div>
        <div class="grid-box p-2 ">
            <div class="grid-items  text-start">
                <div class="flex flex-col  ">
                    <p class="text-lg m-0">{{HeaderKeyMap['todayYield']}} </p>
                    <div><span class="text-2xl">{{cardData.todayYield}}</span></div>
                </div>
            </div>
            <div class="grid-items  text-start">
                <div class="flex flex-col ">
                    <p class="text-lg m-0">{{HeaderKeyMap['totalYield']}} </p>
                    <div><span class="text-2xl">{{cardData.totalYield}}</span></div>
                </div>
            </div>
            <div class="grid-items  text-start">
                <div class="flex flex-col ">
                    <p class="text-lg m-0">{{HeaderKeyMap['PR']}} </p>
                    <div><span class="text-2xl">{{cardData.PR}}</span></div>
                </div>
            </div>
            <div class="grid-items text-start">
                <div class="flex flex-col ">
                    <p class="text-lg m-0">{{HeaderKeyMap['treePlanted']}} </p>
                    <div><span class="text-2xl">{{cardData.treePlanted}}</span></div>
                </div>
            </div>
            <div class="grid-items text-start">
                <div class="flex flex-col ">
                    <p class="text-lg m-0">{{HeaderKeyMap['capacity']}} </p>
                    <div><span class="text-2xl">{{cardData.capacity}}</span></div>
                </div>
            </div>

            <div class="grid-items  text-start">
                <div class="flex flex-col ">
                    <p class="text-lg m-0">{{HeaderKeyMap['revenue']}} </p>
                    <div><span class="text-2xl">{{cardData.revenue}}</span></div>
                </div>
            </div>

            <div class="grid-items  text-start">
                <div class="flex flex-col bo">
                    <p class="text-lg m-0">{{HeaderKeyMap['CUF']}} </p>
                    <div><span class="text-2xl">{{cardData.CUF}}</span></div>
                </div>
            </div>

            <div class="grid-items text-start">
                <div class="flex flex-col bo">
                    <p class="text-lg m-0">{{HeaderKeyMap['co2Saved']}} </p>
                    <div><span class="text-2xl">{{cardData.co2Saved}}</span></div>
                </div>
            </div>

        </div>

        <div class="dark:bg-btTh p-2 rounded-2xl mt-6">

           @if (
            chartOptions &&
            chartOptions.chart?.type &&
            chartOptions.series &&
            chartOptions.series.length > 0
            ) {

            <apx-chart class="w-full h-full bg-dark" [series]="chartOptions.series!" [chart]="chartOptions.chart!"
                [xaxis]="chartOptions.xaxis!" [yaxis]="chartOptions.yaxis!" [tooltip]="chartOptions.tooltip!"
                [dataLabels]="chartOptions.dataLabels!" [stroke]="chartOptions.stroke!"
                [plotOptions]="chartOptions.plotOptions!" [grid]="chartOptions.grid!">
            </apx-chart>

            }

        </div>
    </div>
            }
</div>